import user from './slices/user'
import ui from './slices/ui'

export const reducerList = {
  user,
  ui
}

export type ReducerType = {
  [Key in keyof typeof reducerList]: ReturnType<(typeof reducerList)[Key]>
}

export default reducerList
